export enum ProvisioningOptionsKey {
  speedProfilesUp = 'speedProfilesUp',
  speedProfilesDown = 'speedProfilesDown',
  dbaProfilesUp = 'dbaProfilesUp',
  provisioningSettings = 'provisioningSettings',
  problemsRefreshJobTimestamp = 'problemsRefreshJobTimestamp',
  problemsSettings = 'problemsSettings',
}

export interface IProvisioningOptions {
  speedProfilesUp?: string[];
  speedProfilesDown?: { down: string; xgsPon?: boolean }[];
  dbaProfilesUp?: { up: string; dba: string; xgsPon?: boolean }[];
}
